//-- Copyright (c) 2021 TMT Insights Group, LLC
import { Grid } from '@mui/material';
import { Title, TitleBar } from '@/components/_common';

const AvailsCalendarTitleBar = () => {
  return (
    <TitleBar style={{ marginBottom: 5 }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Title>Release Calendar</Title>
      </Grid>
    </TitleBar>
  );
};

export default AvailsCalendarTitleBar;
